import Core from "./core";

class Header{
    constructor(){
        this.core = new Core();
        this.header = document.querySelector('.header');
        this.page_sub_nav = document.querySelector('.header__flex');
        if (this.header && this.header.querySelector('.hamburger')){
            this.header.querySelector('.hamburger').addEventListener('click', e => {
                this.toggleMenu(e, this.header.querySelector('.header__right'));
                if (this.header.querySelector('.search-mobile').classList.contains('active')){
                    this.header.querySelector('.search-mobile').classList.remove('active');
                    this.slideUp(this.header.querySelector('.header__mobile-search'), 200);
                }
            });
            !this.header.querySelector('.item--sub') || this.header.querySelectorAll('.item--sub').forEach(el => { el.querySelector('a').addEventListener('click', e => this.toggleMenu(e, el.querySelector('.sub-item')))}) 
            !this.header.querySelector('.search-mobile') || this.header.querySelector('.search-mobile').addEventListener('click', e => {
                this.header.querySelector('.search-mobile').classList.toggle('active');
                this.slideToggle(this.header.querySelector('.header__mobile-search'), 500);
                if(this.header.querySelector('.hamburger').classList.contains('active')){
                    this.slideUp(this.header.querySelector('.header__right'), 200);
                    this.header.querySelector('.hamburger').classList.remove('active');
                }
            })
        }
        if (this.header && document.body.clientWidth <= 991){
           // !this.header.querySelector('.sub-menu') || this.header.querySelectorAll('.sub-menu').forEach(el => el.firstElementChild.addEventListener('click', e => this.toggleMenu(e, el.querySelector('ul'))));
        }

        if (this.page_sub_nav && document.body.clientWidth <= 991){
          //  this.page_sub_nav.querySelector('.hamburger').addEventListener('click', e => this.toggleMenu(e, this.page_sub_nav.querySelector('.header__right')));
            // this.page_sub_nav.querySelectorAll('.item.item--sub').forEach(el => el.firstElementChild.addEventListener('click', e => this.toggleMenu(e, el.querySelector('div'))));
            // this.page_sub_nav.querySelectorAll('.item.item--sub').forEach(el => {
            //     el.querySelectorAll('.item--sub').forEach(i => i.firstElementChild.addEventListener('click', e => this.toggleMenu(e, i.querySelector('ul'))));
            // })
        }

        
    }

    toggleMenu(e, itemToggle){
        e.preventDefault();
        e.target.classList.toggle('active');
        this.slideToggle(itemToggle, 500);
    }

    slideUp(target, duration = 500) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    slideDown(target, duration = 500) {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideToggle(target, duration = 500) {
        if (window.getComputedStyle(target).display === 'none') {
            return this.slideDown(target, duration);
        } else {
            return this.slideUp(target, duration);
        }
    }
}

export default Header;